/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InspectionTypeResponse
 */
export interface InspectionTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof InspectionTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionTypeResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionTypeResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the InspectionTypeResponse interface.
 */
export function instanceOfInspectionTypeResponse(value: object): value is InspectionTypeResponse {
    return true;
}

export function InspectionTypeResponseFromJSON(json: any): InspectionTypeResponse {
    return InspectionTypeResponseFromJSONTyped(json, false);
}

export function InspectionTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function InspectionTypeResponseToJSON(json: any): InspectionTypeResponse {
    return InspectionTypeResponseToJSONTyped(json, false);
}

export function InspectionTypeResponseToJSONTyped(value?: InspectionTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

